module.exports = __webpack_public_path__ + "img/banner02.10f37d86.jpg";